"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Pin_1 = __importDefault(require("./Pin"));
class Index {
    constructor(parent, bridgeId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.bridgeId = bridgeId;
    }
    path(withParameter = true) {
        if (withParameter && this.bridgeId !== null) {
            return `${this.parent.path()}/bridges/${this.bridgeId}`;
        }
        return `${this.parent.path()}/bridges`;
    }
    /**
     * Returns a bridge by **bridgeId** identifier.
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async get(queryParams, restRequestConfig) {
        if (this.bridgeId === null) {
            throw new Error('bridgeId must be specified.');
        }
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a bridge by **bridgeId** identifier.
   * Deletion can only be done by bridge owner, his delegate or any user who has the **Super Admin** privilege.
   *
     * HTTP Method: delete
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async delete(restRequestConfig) {
        if (this.bridgeId === null) {
            throw new Error('bridgeId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a bridge by **bridgeId** identifier. The request body should contain JSON object with updating properties.
   * Update can only be done by bridge owner, his delegate or any user who has the **Super Admin** privilege.
   *
     * HTTP Method: patch
     * Endpoint: /rcvideo/v2/bridges/{bridgeId}
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async patch(updateBridgeRequest, restRequestConfig) {
        if (this.bridgeId === null) {
            throw new Error('bridgeId must be specified.');
        }
        const r = await this.rc.patch(this.path(), updateBridgeRequest, undefined, restRequestConfig);
        return r.data;
    }
    pin() {
        return new Pin_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map